import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const TreeContainer = styled.div`
  width: 100%;
  min-height: 600px;
  height: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: visible;
  padding-bottom: 24px;
  transition: all 0.3s ease;
  
  svg {
    width: 100%;
    height: auto;
    min-height: 600px;
    display: block;
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  opacity: ${props => props.show ? 1 : 0};
  max-height: ${props => props.show ? '200px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: top;
  transform: ${props => props.show ? 'scaleY(1)' : 'scaleY(0)'};
  margin-bottom: ${props => props.show ? '24px' : '0'};
  padding: ${props => props.show ? '16px 24px' : '0 24px'};

  .MuiFormControl-root {
    width: 300px;
  }

  .MuiOutlinedInput-root {
    height: 40px;
    font-size: 14px;
  }

  .MuiSelect-select {
    padding: 8px 12px;
  }

  .MuiInputLabel-root {
    transform: translate(12px, 8px) scale(1);
    font-size: 14px;
    
    &.Mui-focused,
    &.MuiFormLabel-filled {
      transform: translate(12px, -9px) scale(0.75);
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const ErrorContainer = styled.div`
  color: #d32f2f;
  padding: 16px;
  text-align: center;
  background: #ffebee;
  border-radius: 4px;
  margin: 16px 0;
`;

export const HeaderButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  
  &:hover {
    background-color: ${COLORS.PRIMARY};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`; 